import React, { useEffect, useState, useCallback, forwardRef } from 'react';
import './choose_method.css';
import Calendar from '../logo/Calendar.svg';
import DatePicker from "react-datepicker";

function PoiOption({name, city, id, image_url, min_spending, max_spending, rating, itin, setItin, checkConflict}) {

    const [startTime, setStartTime] = useState(new Date());
    const [endTime, setEndTime] = useState(new Date());

    const ExampleCustomInput = forwardRef(
      ({ onClick }, ref) => (
      <button className="calendar" onClick={onClick} ref={ref}>
          <img src={Calendar} onClick={onClick} alt="calendar"></img>
      </button>
      ),
    );

    const getItinElement = useCallback(() => {
      let itinElement = {};
      itinElement['id'] = id;
      itinElement['name'] = name;
      itinElement['city'] = city;
      itinElement['image_url'] = image_url;
      itinElement['min_spending'] = min_spending;
      itinElement['max_spending'] = max_spending;
      itinElement['rating'] = rating;
      itinElement['start_time'] = startTime;
      itinElement['end_time'] = endTime;

      return itinElement;
    }, [id, name, city, image_url, min_spending, max_spending, rating, startTime, endTime])

    const getItinElementIdx = useCallback((id) => {
      let idx = -1;
      for(var i = 0; i < itin.length; i++) {
        if (itin[i].id === id) {
          idx = i;
          break;
        }
      }
      return idx;
    }, [itin])

    const updateItinTime = useCallback(() => {
      var idx = getItinElementIdx(id);
      if (idx !== -1) {
        // if exists, replace with updated Itin Element
        itin.splice(idx, 1, getItinElement());
      }
    }, [getItinElementIdx, getItinElement, id, itin])

    useEffect(() => {
      updateItinTime();
      checkConflict();
    }, [startTime, endTime, updateItinTime, checkConflict]);

    const onChangeDate = (date) => {
      setStartTime(date);
      setEndTime(date);
    }

  return (
      <div className="po container-sm">
          <div className="d-flex justify-content-between">
          <div>
            <label className="form-check-label itin h4">
              <input
                className="form-check-input" type="checkbox"
                checked={getItinElementIdx(id) !== -1}

                onChange={(e) => {
                  const checked = (getItinElementIdx(id) !== -1);
                  setItin(prev => checked
                  ?
                  prev.filter(itinElement => itinElement.id !== id)
                  :
                  [...prev, getItinElement()]);
                }}
              />

              {name}
            </label>

            <h6>{city.name}, {city.province}</h6>
            <h5 className="orange">{startTime.toDateString()}</h5>
            <div className="d-flex">
                <DatePicker
                    className="form-control time h5 me-2"
                    selected={startTime}
                    onChange={date => setStartTime(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    />
                    <span> - </span>
                    <DatePicker
                    className="form-control time h5 ms-2"
                    selected={endTime}
                    onChange={date => setEndTime(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    />
            </div>
          </div>
         <div>
            <DatePicker 
            selected={startTime} 
            onChange={date => onChangeDate(date)} 
            closeOnScroll={true}
            customInput={<ExampleCustomInput />}
            dateFormat="MMMM d, yyyy h:mm aa"
            minDate={new Date()}
          />
        </div>
      </div>
    </div>
  );
}

export default PoiOption;
